(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  class CustomAnnouncementBar extends HTMLElement {
    constructor() {
      super();

      this.sectionId = this.dataset.sectionId;
      /*this.storageKey = `custom-announcement-closed-${this.sectionId}`;*/
      this.currentIndex = 0;
      this.interval = null;
    }

    connectedCallback() {
      /*if (this.isClosed()) {
        document.body.classList.remove('has-custom-announcement-bar');
        document.body.style.removeProperty('--custom-announcement-bar-height');

        this.hidden = true;
        return;
        }*/

      this.setAnnouncementHeight();

      this.slides = Array.from(this.querySelectorAll('[data-announcement-slide]'));
      this.prevButton = this.querySelector('[data-announcement-prev]');
      this.nextButton = this.querySelector('[data-announcement-next]');
      this.closeButton = this.querySelector('[data-announcement-close]');
      this.autoplay = this.dataset.autoplay === 'true';
      this.autoplaySpeed = Number(this.dataset.autoplaySpeed) || 3000;

      this.initSlider();
      this.initCountdowns();
      this.bindEvents();
    }

    disconnectedCallback() {
      this.stopAutoplay();
    }

    bindEvents() {
      this.prevButton?.addEventListener('click', () => this.goToPrev());
      this.nextButton?.addEventListener('click', () => this.goToNext());

      this.closeButton?.addEventListener('click', () => {
        this.close();
      });

      this.addEventListener('mouseenter', () => this.stopAutoplay());
      this.addEventListener('mouseleave', () => this.startAutoplay());
    }

    initSlider() {
      if (!this.slides.length) return;

      this.showSlide(this.currentIndex);

      if (this.slides.length > 1 && this.autoplay) {
        this.startAutoplay();
      }
    }

    showSlide(index) {
      if (!this.slides.length) return;

      this.slides.forEach((slide, slideIndex) => {
        slide.classList.toggle('is-active', slideIndex === index);
      });
    }

    goToNext() {
      if (!this.slides.length) return;

      this.currentIndex = (this.currentIndex + 1) % this.slides.length;
      this.showSlide(this.currentIndex);
    }

    goToPrev() {
      if (!this.slides.length) return;

      this.currentIndex = (this.currentIndex - 1 + this.slides.length) % this.slides.length;
      this.showSlide(this.currentIndex);
    }

    startAutoplay() {
      if (!this.autoplay || this.slides.length <= 1 || this.interval) return;

      this.interval = window.setInterval(() => {
        this.goToNext();
      }, this.autoplaySpeed);
    }

    stopAutoplay() {
      if (!this.interval) return;

      window.clearInterval(this.interval);
      this.interval = null;
    }

    close() {
        /*window.localStorage.setItem(this.storageKey, 'true');*/

        document.body.classList.remove('has-custom-announcement-bar');
        document.body.style.removeProperty('--custom-announcement-bar-height');

        this.hidden = true;
        this.stopAutoplay();
    }

    /*isClosed() {
      return window.localStorage.getItem(this.storageKey) === 'true';
    }*/

    initCountdowns() {
      const countdowns = this.querySelectorAll('[data-countdown]');

      countdowns.forEach((countdown) => {
        this.updateCountdown(countdown);

        window.setInterval(() => {
          this.updateCountdown(countdown);
        }, 1000);
      });
    }

    updateCountdown(countdown) {
      const dateValue = countdown.dataset.countdownDate;
      const targetDate = new Date(dateValue).getTime();

      if (!targetDate) return;

      const now = new Date().getTime();
      const distance = targetDate - now;

      const daysEl = countdown.querySelector('[data-days]');
      const hoursEl = countdown.querySelector('[data-hours]');
      const minutesEl = countdown.querySelector('[data-minutes]');
      const secondsEl = countdown.querySelector('[data-seconds]');

      if (distance <= 0) {
        daysEl.textContent = '00';
        hoursEl.textContent = '00';
        minutesEl.textContent = '00';
        secondsEl.textContent = '00';
        return;
      }

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance / (1000 * 60 * 60)) % 24);
      const minutes = Math.floor((distance / (1000 * 60)) % 60);
      const seconds = Math.floor((distance / 1000) % 60);

      daysEl.textContent = String(days).padStart(2, '0');
      hoursEl.textContent = String(hours).padStart(2, '0');
      minutesEl.textContent = String(minutes).padStart(2, '0');
      secondsEl.textContent = String(seconds).padStart(2, '0');
    }

    setAnnouncementHeight() {
        const allAnnouncementBars = Array.from(document.querySelectorAll('custom-announcement-bar'));

        if (allAnnouncementBars.length && allAnnouncementBars[0] !== this) {
            return;
        }

        const updateHeight = () => {
            const inner = this.querySelector('.custom-announcement-bar__inner');
            const viewport = this.querySelector('.custom-announcement-bar__viewport');
            const item = this.querySelector('.custom-announcement-bar__item');

            const heights = [
            this.getBoundingClientRect().height,
            this.offsetHeight,
            this.scrollHeight,
            inner?.getBoundingClientRect().height,
            inner?.offsetHeight,
            inner?.scrollHeight,
            viewport?.getBoundingClientRect().height,
            viewport?.offsetHeight,
            item?.getBoundingClientRect().height,
            item?.offsetHeight
            ].filter(Boolean);

            const height = Math.ceil(Math.max(...heights, 32));

            document.body.classList.add('has-custom-announcement-bar');
            document.body.style.setProperty('--custom-announcement-bar-height', `${height}px`);
        };

        updateHeight();

        window.requestAnimationFrame(updateHeight);
        window.setTimeout(updateHeight, 100);
        window.setTimeout(updateHeight, 300);
        window.setTimeout(updateHeight, 700);
        window.setTimeout(updateHeight, 1200);

        window.addEventListener('resize', updateHeight);
        window.addEventListener('load', updateHeight);
        }
  }

  if (!customElements.get('custom-announcement-bar')) {
    customElements.define('custom-announcement-bar', CustomAnnouncementBar);
  }

  } catch(e) { console.error(e); }
})();
})();
